// extracted by mini-css-extract-plugin
export default {"loginPageContainer":"Login_loginPageContainer__Owdbo","loginPage":"Login_loginPage__qBk3u","leftSide":"Login_leftSide__KeBGS","rightSide":"Login_rightSide__r6sZ6"};